import { getBasenameAndIndexWithoutExtension, getBasenameWithoutExtension, getExtname } from '../platformAbstraction/pathComposition';
import { splitAt } from './general';

export const getPossibleItemIdAndIndexFromFileName = (fileName: string, pathSep: string) => {
  if (!fileName) return;

  let { result: fileId, index } = getBasenameAndIndexWithoutExtension(fileName, pathSep);
  const indexOfDelimiter = fileId.lastIndexOf('_');
  if (indexOfDelimiter > -1) {
    fileId = splitAt(indexOfDelimiter)(fileId)[1];
    index += indexOfDelimiter + 1;
  }
  return { possibleId: fileId, index };
};

/**
 * Extracts the possible Mimir itemId from a fileName
 * The fileName format should be like: some-file-specific-info_mimirItemId.ext
 * @param fileName - FileName to parse, may contain full directory path
 */
export const getPossibleItemIdFromFileName = (fileName: string, pathSep: string) => {
  return getPossibleItemIdAndIndexFromFileName(fileName, pathSep)?.possibleId;
};

export const getFileNameFromMangledWithId = (fileName: string, pathSep: string) => {
  const ext = getExtname(fileName, pathSep);
  const fileBaseName = getBasenameWithoutExtension(fileName, pathSep);
  const indexOfDelimiter = fileBaseName.lastIndexOf('_');
  let name = fileBaseName;
  if (indexOfDelimiter > -1) {
    [name] = splitAt(indexOfDelimiter)(fileBaseName);
  }
  return `${name}${ext}`;
};

// Splits file name and extension and injects an ID value with underscore as a delimiter
export const mangleFileNameWithId = (fileName: string, id: string, excludeOriginalName: boolean = false): string => {
  const [filePrefix, ext] = splitAt(fileName.lastIndexOf('.'))(fileName);
  if (!excludeOriginalName && filePrefix.endsWith(id)) {
    return fileName;
  }
  const mangledFileName = excludeOriginalName ? `${id}.${ext}` : `${filePrefix}_${id}.${ext}`;

  return mangledFileName;
};
